<template>
  <!-- Tablero de control -->
  <v-form ref="form" autocomplete="off">
    <v-row>
      <!-- Riesgo  -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.Riesgo_ID"
          :items="ArrayRiesgo"
          :item-title="
            (ArrayRiesgo) =>
              ArrayRiesgo.Riesgo_ID + '-' + ArrayRiesgo.Descripcion
          "
          item-value="Riesgo_ID"
          color="primary"
          label="Riesgo:"
          dense
          clearable
          :rules="[(v) => !!v || 'Campo obligatorio']"
        >
        </v-autocomplete>
      </v-col>
      <!-- Estado -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.Estado"
          :update:modelValue="ChangeEstado()"
          :items="ArrayEstado"
          :item-title="
            (ArrayEstado) =>
              ArrayEstado.ValorNumero + '-' + ArrayEstado.Descripcion
          "
          item-value="ValorNumero"
          color="primary"
          label="Estado:"
          dense
          clearable
          :rules="[(v) => !!v || 'Campo obligatorio']"
        >
        </v-autocomplete>
      </v-col>
      <!--Fecha Inicio-->
      <v-col cols="12" sm="12" md="6">
        <v-text-field
          v-model="editedItem.FechaIngreso"
          label="Fecha Inicio:"
          type="date"
          :rules="[(v) => !!v || 'Campo obligatorio']"
          clearable
        ></v-text-field>
      </v-col>
      <!--Fecha Finalización-->
      <v-col v-if="editedItem.Estado == '2'" cols="12" sm="12" md="6">
        <v-text-field
          v-model="editedItem.FechaRetiro"
          label="Fecha Finalización:"
          type="date"
          :rules="[(v) => !!v || 'Campo obligatorio']"
          clearable
        ></v-text-field>
      </v-col>
      <!-- Observaciones -->
      <v-col cols="12" sm="6" md="12">
        <v-textarea
          v-model="editedItem.Observaciones"
          name="input-7-1"
          filled
          label="Observaciones"
          auto-grow
          clearable
        ></v-textarea>
      </v-col>
    </v-row>
    <!--////////////////////////////////////////////// Auditoria ////////////////////////////////////////////////////////////-->
    <br />
    <v-row>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Creación: {{ editedItem.UsuarioCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span
          >Usuario Actualización: {{ editedItem.UsuarioActualizacion }}</span
        >
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Creación: {{ editedItem.FechaCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Actualización: {{ editedItem.FechaActualizacion }}</span>
      </v-col>
    </v-row>
    <div align="right">
      <br />
      <v-btn
        size="x-large"
        v-if="!buttonSave"
        color="green"
        text
        @click="ValidateCampos"
      >
        Guardar
      </v-btn>
    </div>
  </v-form>
  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "seguros_registro",
  props: {
    editedIndex: {
      type: Number,
      default: 0,
      Description: "Cambia de actualización a creación o visceversa",
    },
    infoedit: {
      type: Object,
      default: [],
      Description: "Información de datos",
    },
    tipodocumento: {
      type: Number,
      default: 0,
      Description: "Información de tipo de documento",
    },
    documento: {
      type: String,
      default: "",
      Description: "Información de documento",
    },
    page: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
    Exito: {
      type: String,
      default: "",
      Description: "Información de respuesta post o put",
    },
  },
  data() {
    return {
      progreso: false,
      componenteview: 0,
      buttonSave: false,
      editedItem: {
        Secuencia: null,
        TypeDocument_ID: null,
        Documento_ID: null,
        Riesgo_ID: null,
        FechaIngreso: null,
        FechaRetiro: null,
        Estado: null,
        Observaciones: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      defaultItem: {
        Secuencia: null,
        TypeDocument_ID: null,
        Documento_ID: null,
        Riesgo_ID: null,
        FechaIngreso: null,
        FechaRetiro: null,
        Estado: null,
        Observaciones: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      ArrayRiesgo: [],
      ArrayEstado: [],
      westado: null,
    };
  },
  methods: {
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Validación de campos
    async ValidateCampos() {
      var validate = false;
      debugger;
      if (
        this.editedItem.TypeDocument_ID == "" ||
        this.editedItem.TypeDocument_ID == null ||
        this.editedItem.Documento_ID == "" ||
        this.editedItem.Documento_ID == null ||
        this.editedItem.Riesgo_ID == "" ||
        this.editedItem.Riesgo_ID == null ||
        this.editedItem.FechaIngreso == "" ||
        this.editedItem.FechaIngreso == null ||
        (this.editedItem.Estado == "" ||
        this.editedItem.Estado == null)
      ) {
        console.log(this.editedItem);
        validate = true;
      } else if (
        this.editedItem.Estado == "2" &&
        (this.editedItem.FechaRetiro == "" ||
          this.editedItem.FechaRetiro == null)
      ) {
        validate = true;
      }
      // Consultas a Ejecutar
      if (!validate) {
        var userperfil = this.$store.getters.userperfil;
        this.editedItem.UsuarioActualizacion = userperfil.userInfo.Usuario_ID;
        this.editedItem.UsuarioCreacion = userperfil.userInfo.Usuario_ID;
        if (this.editedIndex != -1) {
          this.putRegistro();
        } else {
          this.postRegistro();
        }
      } else {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos.",
        });
        this.$refs.form.validate();
      }
    },
    // Crear Registro
    async postRegistro() {
      this.progreso = true;
      this.axios
        .post("/personas/riesgos/CR0/", this.editedItem)
        .then((result) => {
          this.reset();
          var data = false;
          this.$emit("update:page", data);
          this.$emit("update:Exito", result.data);
          this.$swal({
            icon: "success",
            title: "¡Éxito!",
            html: " El registro fue guardado correctamente.",
          });
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El sistena ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
    // Actualizacion de registro
    async putRegistro() {
      this.progreso = true;
      this.axios
        .put("/personas/riesgos/", this.editedItem)
        .then((response) => {
          this.reset();
          var data = false;
          this.$emit("update:page", data);
          this.$emit("update:Exito", response.data);
          this.$swal({
            icon: "success",
            title: "¡Éxito!",
            html: " El registro fue guardado correctamente.",
          });
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El sistena ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
    ///////////////////////////////////////////////// Changes ///////////////////////////////////////////
    // Método de gestion Estado
    ChangeEstado() {
      if (this.westado != this.editedItem.Estado) {
        this.westado = this.editedItem.Estado;
        if (this.editedItem.Estado == 1) {
          this.editedItem.FechaRetiro = null;
        }
        if (this.editedItem.Estado == null || this.editedItem.Estado == "") {
          this.editedItem.FechaRetiro = null;
        }
      }
    },
    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    reset() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.westado = null;
    },
    // Cargue Combos
    CargueCombos() {
      this.westado = null;
      var ArrayRisk = this.$store.getters.MRisk;
      this.ArrayRiesgo = ArrayRisk.filter((item) => item.Riesgo_ID != 0);
      this.ArrayEstado = this.$store.getters.MTablaSeleccion[51].TablaSeleccion;
    },
    // Actualizar carga
    ActualizarCargue() {
      if (this.editedIndex != -1) {
        // Actualizar
        this.editedItem = this.infoedit;
      } else {
        this.editedItem.TypeDocument_ID =
          this.tipodocumento != 0 ? this.tipodocumento : null;
        this.editedItem.Documento_ID =
          this.documento != null ? this.documento : null;
      }
    },
  },
  mounted() {
    this.CargueCombos();
    this.ActualizarCargue();
  },
};
</script>
